import Paper, { type PaperProps } from '@mui/material/Paper';

export const DiscountBadge = ({ ...props }: PaperProps): JSX.Element => (
  <Paper {...props} variant="discountBadge" />
);
